var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'route-'+_vm.routeName,attrs:{"id":"app-wrapper"}},[(!_vm.featureFlagsLoadingState)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }